export default {
    _mode: null,
    _store: null,

    clear(onlySession) {
        if (onlySession) {
            let keys = ["token_info", "user"];

            keys.forEach(key => {
                if (this._mode === "localStorage") {
                    localStorage.removeItem(key);
                }
            });
        } else {
            if (this._mode === "localStorage") {
                localStorage.clear();
            }
        }
    },

    set(key, data, asJson) {
        if (this._mode === "localStorage") {
            localStorage.setItem(key, asJson ? JSON.stringify(data) : data);
        }
    },

    get(key, defaultValue, fromJson) {
        var value = null;

        if (this._mode === "localStorage") {
            value = localStorage.getItem(key);
        }

        if (value && fromJson) {
            return JSON.parse(value);
        }

        return value || defaultValue;
    },

    delete(key) {
        if (this._mode === "localStorage") {
            localStorage.removeItem(key);
        }
    },

    init(mode) {
        this._mode = mode || "localStorage";

        return this;
    }
}